module.exports = __webpack_public_path__ + "img/product15-dashuju.b0e06141.svg";